import React, { useEffect } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './CTAButton';
import { CheckCircle2, XCircle, Lock, ShieldCheck, Bot, Zap, MessageSquare, BarChart3, FileText, Settings, TrendingUp, Download, Smartphone, Check } from 'lucide-react';
export function SalesPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-indigo-200" data-id="element-7">
      <CountdownTimer data-id="element-8" />
      <SocialProofPopup data-id="element-9" />

      {/* SECTION 1 - HERO */}
      <section className="pt-4 pb-12 px-4 max-w-5xl mx-auto text-center" data-id="element-10">
        <div className="inline-flex items-center gap-2 bg-indigo-50 border border-indigo-200 rounded-full px-6 py-2 mb-4" data-id="element-11">
          <Bot className="w-5 h-5 text-indigo-600" data-id="element-12" />
          <p className="text-indigo-800 font-semibold text-sm md:text-base" data-id="element-13">
            Inteligencia Artificial para Contadores
          </p>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight mb-2 uppercase text-center text-balance" data-id="element-14">
          <span className="block text-indigo-600 my-1 text-[45px]" data-id="element-15">
            100 PROMPTS listos para usar con ia
          </span>
        </h1>

        <h2 className="md:text-2xl font-bold text-amber-600 mb-6 max-w-4xl mx-auto text-balance text-[18px]" data-id="element-16">
          Diseñados específicamente para contadores que te ayudaran a ahorrar
          hasta 10 horas de trabajo por semana
        </h2>

        <a href="#compra" className="block max-w-3xl mx-auto mb-5 cursor-pointer hover:opacity-95 transition-opacity" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/cHyzj99Qi9NwdZXEVW7doL/ChatGPT_Image_7_mar_2026,_00_40_32.png" alt="100 Prompts de ChatGPT para Contadores" className="w-full rounded-xl shadow-2xl" data-id="element-18" />
        </a>

        <p className="md:text-4xl font-black text-red-600 mb-4 text-[22px]" data-id="element-19">
          El 70% del trabajo de un contador se va en tareas repetitivas.
        </p>

        <p className="text-xl md:text-2xl text-slate-600 mb-5 font-medium max-w-3xl mx-auto" data-id="element-20">
          Responder consultas de clientes, explicar impuestos, redactar correos,
          analizar información financiera…
        </p>

        <p className="text-xl md:text-2xl text-slate-700 mb-5 font-bold" data-id="element-21">
          Pero hoy puedes automatizar gran parte de ese trabajo usando
          inteligencia artificial.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 md:gap-6 mb-8 font-semibold text-slate-700" data-id="element-22">
          <span className="flex items-center gap-2" data-id="element-23">
            <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-24" />{' '}
            100 prompts listos para copiar y usar
          </span>
          <span className="flex items-center gap-2" data-id="element-25">
            <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-26" />{' '}
            Diseñado para contadores y estudios contables
          </span>
          <span className="flex items-center gap-2" data-id="element-27">
            <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-28" />{' '}
            Automatiza tareas contables en segundos
          </span>
        </div>

        <CTAButton text="👉 QUIERO LOS 100 PROMPTS PARA CONTADORES" href="#compra" data-id="element-29" />
      </section>

      {/* NEW SECTION - DISEÑADO ESPECÍFICAMENTE */}
      <section className="bg-indigo-900 text-white py-20 px-4" data-id="element-30">
        <div className="max-w-4xl mx-auto text-center" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-black mb-6 text-amber-400" data-id="element-32">
            Diseñado específicamente para la profesión contable
          </h2>
          <p className="text-xl md:text-2xl font-medium mb-10 text-indigo-100" data-id="element-33">
            Este ebook fue creado pensando en el trabajo real que realizan los
            contadores todos los días.
          </p>

          <p className="text-lg md:text-xl font-bold mb-8 text-white" data-id="element-34">
            Los prompts incluidos están diseñados para ayudarte con tareas como:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto mb-12 text-left" data-id="element-35">
            <div className="bg-indigo-800/50 p-4 rounded-lg flex items-center gap-3 border border-indigo-700" data-id="element-36">
              <Check className="text-green-400 w-5 h-5 flex-shrink-0" data-id="element-37" />
              <span className="font-medium text-lg" data-id="element-38">
                responder consultas sobre IVA
              </span>
            </div>
            <div className="bg-indigo-800/50 p-4 rounded-lg flex items-center gap-3 border border-indigo-700" data-id="element-39">
              <Check className="text-green-400 w-5 h-5 flex-shrink-0" data-id="element-40" />
              <span className="font-medium text-lg" data-id="element-41">
                explicar impuestos a clientes
              </span>
            </div>
            <div className="bg-indigo-800/50 p-4 rounded-lg flex items-center gap-3 border border-indigo-700" data-id="element-42">
              <Check className="text-green-400 w-5 h-5 flex-shrink-0" data-id="element-43" />
              <span className="font-medium text-lg" data-id="element-44">analizar balances</span>
            </div>
            <div className="bg-indigo-800/50 p-4 rounded-lg flex items-center gap-3 border border-indigo-700" data-id="element-45">
              <Check className="text-green-400 w-5 h-5 flex-shrink-0" data-id="element-46" />
              <span className="font-medium text-lg" data-id="element-47">
                generar informes financieros
              </span>
            </div>
            <div className="bg-indigo-800/50 p-4 rounded-lg flex items-center gap-3 border border-indigo-700" data-id="element-48">
              <Check className="text-green-400 w-5 h-5 flex-shrink-0" data-id="element-49" />
              <span className="font-medium text-lg" data-id="element-50">
                organizar vencimientos
              </span>
            </div>
            <div className="bg-indigo-800/50 p-4 rounded-lg flex items-center gap-3 border border-indigo-700" data-id="element-51">
              <Check className="text-green-400 w-5 h-5 flex-shrink-0" data-id="element-52" />
              <span className="font-medium text-lg" data-id="element-53">gestionar clientes</span>
            </div>
          </div>

          <div className="bg-amber-500/10 border border-amber-500/30 p-6 rounded-xl inline-block" data-id="element-54">
            <p className="text-xl md:text-2xl font-bold text-amber-400 mb-2" data-id="element-55">
              No son prompts genéricos.
            </p>
            <p className="text-lg md:text-xl text-indigo-100" data-id="element-56">
              Son prompts pensados para situaciones reales dentro de un estudio
              contable.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 2 - THE PROBLEM */}
      <section className="bg-slate-50 py-20 px-4 border-y border-slate-200" data-id="element-57">
        <div className="max-w-4xl mx-auto" data-id="element-58">
          <h3 className="text-3xl md:text-4xl font-black text-center mb-4 text-slate-900" data-id="element-59">
            El problema que viven la mayoría de los contadores
          </h3>
          <p className="text-xl text-center text-slate-600 mb-10 font-medium" data-id="element-60">
            Si eres contador, probablemente tu día se parece a esto:
          </p>

          <div className="space-y-6 text-lg md:text-xl font-medium bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-slate-100" data-id="element-61">
            <p className="flex items-start gap-4" data-id="element-62">
              <span className="text-2xl" data-id="element-63">📱</span>
              <span data-id="element-64">Clientes preguntando todo el tiempo</span>
            </p>
            <p className="flex items-start gap-4" data-id="element-65">
              <span className="text-2xl" data-id="element-66">📑</span>
              <span data-id="element-67">Explicando impuestos una y otra vez</span>
            </p>
            <p className="flex items-start gap-4" data-id="element-68">
              <span className="text-2xl" data-id="element-69">📊</span>
              <span data-id="element-70">Analizando información financiera manualmente</span>
            </p>
            <p className="flex items-start gap-4" data-id="element-71">
              <span className="text-2xl" data-id="element-72">📧</span>
              <span data-id="element-73">Redactando correos repetitivos</span>
            </p>
            <p className="flex items-start gap-4" data-id="element-74">
              <span className="text-2xl" data-id="element-75">⏰</span>
              <span data-id="element-76">Vencimientos constantes</span>
            </p>
          </div>

          <div className="mt-12 text-center text-xl md:text-2xl font-bold space-y-2" data-id="element-77">
            <p className="text-slate-600" data-id="element-78">El resultado:</p>
            <p className="text-red-600 text-3xl md:text-4xl mt-4 font-black" data-id="element-79">
              Horas y horas de trabajo repetitivo.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 - THE TRANSITION */}
      <section className="bg-slate-900 text-white py-20 px-4" data-id="element-80">
        <div className="max-w-4xl mx-auto text-center" data-id="element-81">
          <Zap className="w-16 h-16 text-amber-400 mx-auto mb-8" data-id="element-82" />
          <p className="text-2xl md:text-3xl font-medium mb-8 leading-relaxed" data-id="element-83">
            Pero hoy existe una herramienta que está cambiando la forma en que
            trabajan los profesionales.
          </p>
          <h2 className="text-5xl md:text-6xl font-black mb-8 text-indigo-400" data-id="element-84">
            La inteligencia artificial.
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-slate-300" data-id="element-85">
            Y si sabes usarla bien…
            <span className="block text-amber-400 mt-4 text-4xl md:text-5xl" data-id="element-86">
              puedes ahorrar muchísimo tiempo.
            </span>
          </p>
        </div>
      </section>

      {/* SECTION 4 - THE SOLUTION */}
      <section className="py-20 px-4 bg-white" data-id="element-87">
        <div className="max-w-5xl mx-auto text-center" data-id="element-88">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-6 py-2 rounded-full text-xl mb-6" data-id="element-89">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-slate-900" data-id="element-90">
            Usar ChatGPT como asistente contable
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 mb-12 max-w-3xl mx-auto" data-id="element-91">
            Este ebook reúne 100 prompts profesionales diseñados para
            contadores. Cada prompt está diseñado para que puedas:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16 text-left max-w-4xl mx-auto" data-id="element-92">
            <div className="bg-indigo-50 p-6 rounded-xl border border-indigo-100 flex items-start gap-4" data-id="element-93">
              <CheckCircle2 className="text-indigo-600 w-6 h-6 flex-shrink-0 mt-1" data-id="element-94" />
              <span className="font-semibold text-lg text-slate-800" data-id="element-95">
                Responder consultas de clientes
              </span>
            </div>
            <div className="bg-indigo-50 p-6 rounded-xl border border-indigo-100 flex items-start gap-4" data-id="element-96">
              <CheckCircle2 className="text-indigo-600 w-6 h-6 flex-shrink-0 mt-1" data-id="element-97" />
              <span className="font-semibold text-lg text-slate-800" data-id="element-98">
                Analizar datos contables
              </span>
            </div>
            <div className="bg-indigo-50 p-6 rounded-xl border border-indigo-100 flex items-start gap-4" data-id="element-99">
              <CheckCircle2 className="text-indigo-600 w-6 h-6 flex-shrink-0 mt-1" data-id="element-100" />
              <span className="font-semibold text-lg text-slate-800" data-id="element-101">
                Generar informes profesionales
              </span>
            </div>
            <div className="bg-indigo-50 p-6 rounded-xl border border-indigo-100 flex items-start gap-4 lg:col-start-1 lg:col-end-2 lg:translate-x-1/2" data-id="element-102">
              <CheckCircle2 className="text-indigo-600 w-6 h-6 flex-shrink-0 mt-1" data-id="element-103" />
              <span className="font-semibold text-lg text-slate-800" data-id="element-104">
                Explicar normativa fiscal
              </span>
            </div>
            <div className="bg-indigo-50 p-6 rounded-xl border border-indigo-100 flex items-start gap-4 lg:col-start-2 lg:col-end-3 lg:translate-x-1/2" data-id="element-105">
              <CheckCircle2 className="text-indigo-600 w-6 h-6 flex-shrink-0 mt-1" data-id="element-106" />
              <span className="font-semibold text-lg text-slate-800" data-id="element-107">
                Organizar tu estudio contable
              </span>
            </div>
          </div>

          <p className="text-3xl font-black text-slate-900 mb-10" data-id="element-108">
            Todo en segundos. Solo debes:
          </p>

          <div className="flex flex-col md:flex-row justify-center items-stretch gap-6 max-w-4xl mx-auto" data-id="element-109">
            <div className="flex-1 bg-white p-8 rounded-2xl border-2 border-slate-100 shadow-xl relative mt-6 md:mt-0" data-id="element-110">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-indigo-600 text-white rounded-full flex items-center justify-center text-2xl font-black border-4 border-white" data-id="element-111">
                1
              </div>
              <h4 className="text-xl font-bold text-slate-900 mt-4" data-id="element-112">
                Copiar el prompt
              </h4>
            </div>
            <div className="flex-1 bg-white p-8 rounded-2xl border-2 border-slate-100 shadow-xl relative mt-6 md:mt-0" data-id="element-113">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-indigo-600 text-white rounded-full flex items-center justify-center text-2xl font-black border-4 border-white" data-id="element-114">
                2
              </div>
              <h4 className="text-xl font-bold text-slate-900 mt-4" data-id="element-115">
                Pegarlo en ChatGPT
              </h4>
            </div>
            <div className="flex-1 bg-indigo-600 p-8 rounded-2xl border-2 border-indigo-600 shadow-xl relative mt-6 md:mt-0 text-white transform md:scale-105" data-id="element-116">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-amber-400 text-slate-900 rounded-full flex items-center justify-center text-2xl font-black border-4 border-white" data-id="element-117">
                3
              </div>
              <h4 className="text-xl font-bold mt-4" data-id="element-118">Obtener la respuesta</h4>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 - WHAT'S INSIDE */}
      <section className="py-20 px-4 bg-slate-50 border-t border-slate-200" data-id="element-119">
        <div className="max-w-6xl mx-auto" data-id="element-120">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-6 text-slate-900" data-id="element-121">
            ¿Qué encontrarás dentro del ebook?
          </h2>
          <p className="text-xl md:text-2xl text-center text-indigo-600 mb-16 font-bold" data-id="element-122">
            100 Prompts profesionales organizados en 5 áreas
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-123">
            {/* Area 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-indigo-500" data-id="element-124">
              <MessageSquare className="w-10 h-10 text-indigo-500 mb-4" data-id="element-125" />
              <h3 className="text-2xl font-bold mb-3 text-slate-900" data-id="element-126">
                Comunicación con clientes
              </h3>
              <p className="text-slate-600 italic mb-6" data-id="element-127">
                Responde consultas de forma profesional en segundos.
              </p>
              <div className="bg-slate-50 p-4 rounded-lg" data-id="element-128">
                <p className="text-sm font-bold text-slate-500 uppercase mb-3" data-id="element-129">
                  Ejemplos incluidos:
                </p>
                <ul className="space-y-2 font-medium text-slate-700" data-id="element-130">
                  <li className="flex items-start gap-2" data-id="element-131">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-132"></div>{' '}
                    explicar IVA a un cliente
                  </li>
                  <li className="flex items-start gap-2" data-id="element-133">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-134"></div>{' '}
                    responder consultas fiscales
                  </li>
                  <li className="flex items-start gap-2" data-id="element-135">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-136"></div>{' '}
                    redactar correos profesionales
                  </li>
                  <li className="flex items-start gap-2" data-id="element-137">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-138"></div>{' '}
                    explicar vencimientos
                  </li>
                </ul>
              </div>
            </div>

            {/* Area 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-indigo-500" data-id="element-139">
              <BarChart3 className="w-10 h-10 text-indigo-500 mb-4" data-id="element-140" />
              <h3 className="text-2xl font-bold mb-3 text-slate-900" data-id="element-141">
                Análisis contable
              </h3>
              <p className="text-slate-600 italic mb-6" data-id="element-142">
                Analiza información financiera rápidamente.
              </p>
              <div className="bg-slate-50 p-4 rounded-lg" data-id="element-143">
                <p className="text-sm font-bold text-slate-500 uppercase mb-3" data-id="element-144">
                  Ejemplos incluidos:
                </p>
                <ul className="space-y-2 font-medium text-slate-700" data-id="element-145">
                  <li className="flex items-start gap-2" data-id="element-146">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-147"></div>{' '}
                    análisis de balances
                  </li>
                  <li className="flex items-start gap-2" data-id="element-148">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-149"></div>{' '}
                    detección de inconsistencias
                  </li>
                  <li className="flex items-start gap-2" data-id="element-150">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-151"></div>{' '}
                    análisis de gastos
                  </li>
                  <li className="flex items-start gap-2" data-id="element-152">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-153"></div>{' '}
                    interpretación de resultados
                  </li>
                </ul>
              </div>
            </div>

            {/* Area 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-indigo-500" data-id="element-154">
              <FileText className="w-10 h-10 text-indigo-500 mb-4" data-id="element-155" />
              <h3 className="text-2xl font-bold mb-3 text-slate-900" data-id="element-156">
                Informes profesionales
              </h3>
              <p className="text-slate-600 italic mb-6" data-id="element-157">
                Crea informes claros y profesionales para tus clientes.
              </p>
              <div className="bg-slate-50 p-4 rounded-lg" data-id="element-158">
                <p className="text-sm font-bold text-slate-500 uppercase mb-3" data-id="element-159">
                  Ejemplos incluidos:
                </p>
                <ul className="space-y-2 font-medium text-slate-700" data-id="element-160">
                  <li className="flex items-start gap-2" data-id="element-161">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-162"></div>{' '}
                    resumen ejecutivo financiero
                  </li>
                  <li className="flex items-start gap-2" data-id="element-163">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-164"></div>{' '}
                    informes contables
                  </li>
                  <li className="flex items-start gap-2" data-id="element-165">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-166"></div>{' '}
                    conclusiones profesionales
                  </li>
                  <li className="flex items-start gap-2" data-id="element-167">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-168"></div>{' '}
                    recomendaciones financieras
                  </li>
                </ul>
              </div>
            </div>

            {/* Area 4 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-indigo-500 lg:col-start-1 lg:col-end-2 lg:translate-x-1/2" data-id="element-169">
              <Settings className="w-10 h-10 text-indigo-500 mb-4" data-id="element-170" />
              <h3 className="text-2xl font-bold mb-3 text-slate-900" data-id="element-171">
                Automatizar tu estudio
              </h3>
              <p className="text-slate-600 italic mb-6" data-id="element-172">
                Optimiza procesos internos.
              </p>
              <div className="bg-slate-50 p-4 rounded-lg" data-id="element-173">
                <p className="text-sm font-bold text-slate-500 uppercase mb-3" data-id="element-174">
                  Ejemplos incluidos:
                </p>
                <ul className="space-y-2 font-medium text-slate-700" data-id="element-175">
                  <li className="flex items-start gap-2" data-id="element-176">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-177"></div>{' '}
                    organización de clientes
                  </li>
                  <li className="flex items-start gap-2" data-id="element-178">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-179"></div>{' '}
                    checklist contables
                  </li>
                  <li className="flex items-start gap-2" data-id="element-180">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-181"></div>{' '}
                    planificación mensual
                  </li>
                  <li className="flex items-start gap-2" data-id="element-182">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-183"></div>{' '}
                    organización de vencimientos
                  </li>
                </ul>
              </div>
            </div>

            {/* Area 5 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-indigo-500 lg:col-start-2 lg:col-end-3 lg:translate-x-1/2" data-id="element-184">
              <TrendingUp className="w-10 h-10 text-indigo-500 mb-4" data-id="element-185" />
              <h3 className="text-2xl font-bold mb-3 text-slate-900" data-id="element-186">
                Mejorar productividad
              </h3>
              <p className="text-slate-600 italic mb-6" data-id="element-187">
                Organiza mejor tu trabajo.
              </p>
              <div className="bg-slate-50 p-4 rounded-lg" data-id="element-188">
                <p className="text-sm font-bold text-slate-500 uppercase mb-3" data-id="element-189">
                  Ejemplos incluidos:
                </p>
                <ul className="space-y-2 font-medium text-slate-700" data-id="element-190">
                  <li className="flex items-start gap-2" data-id="element-191">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-192"></div>{' '}
                    planificación del mes contable
                  </li>
                  <li className="flex items-start gap-2" data-id="element-193">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-194"></div>{' '}
                    organización de tareas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-195">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-indigo-400 rounded-full flex-shrink-0" data-id="element-196"></div>{' '}
                    priorización de trabajo
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 - WHO IS THIS FOR */}
      <section className="py-20 px-4 bg-white" data-id="element-197">
        <div className="max-w-4xl mx-auto" data-id="element-198">
          <div className="bg-indigo-900 text-white rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-199">
            <div className="absolute top-0 right-0 -mt-10 -mr-10 text-indigo-800 opacity-50" data-id="element-200">
              <Bot className="w-64 h-64" data-id="element-201" />
            </div>

            <div className="relative z-10" data-id="element-202">
              <h3 className="text-3xl md:text-4xl font-black mb-8 text-amber-400" data-id="element-203">
                ¿Para quién es este ebook?
              </h3>
              <p className="text-xl mb-8 font-medium" data-id="element-204">
                Este material es ideal para:
              </p>

              <ul className="space-y-4 font-medium text-lg md:text-xl mb-10" data-id="element-205">
                <li className="flex items-center gap-3" data-id="element-206">
                  <CheckCircle2 className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-207" />{' '}
                  Contadores independientes
                </li>
                <li className="flex items-center gap-3" data-id="element-208">
                  <CheckCircle2 className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-209" />{' '}
                  Estudios contables
                </li>
                <li className="flex items-center gap-3" data-id="element-210">
                  <CheckCircle2 className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-211" />{' '}
                  Profesionales de finanzas
                </li>
                <li className="flex items-center gap-3" data-id="element-212">
                  <CheckCircle2 className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-213" />{' '}
                  Consultores fiscales
                </li>
              </ul>

              <div className="bg-indigo-800/50 p-6 rounded-xl border border-indigo-700" data-id="element-214">
                <p className="text-xl font-bold text-white" data-id="element-215">
                  Si trabajas con clientes y tareas contables repetitivas, este
                  ebook puede ayudarte a ahorrar muchas horas de trabajo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NEW SECTION - EJEMPLO REAL DE UN PROMPT */}
      <section className="py-20 px-4 bg-slate-50 border-t border-slate-200" data-id="element-216">
        <div className="max-w-4xl mx-auto" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-slate-900" data-id="element-218">
            Ejemplo real de un prompt incluido en el ebook
          </h2>

          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden" data-id="element-219">
            {/* Prompt Box */}
            <div className="p-8 border-b border-slate-200 bg-indigo-50/50" data-id="element-220">
              <div className="flex items-center gap-3 mb-4" data-id="element-221">
                <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-222">
                  <MessageSquare className="w-6 h-6 text-indigo-600" data-id="element-223" />
                </div>
                <h3 className="text-xl font-bold text-slate-900" data-id="element-224">PROMPT:</h3>
              </div>
              <div className="bg-white p-6 rounded-xl border border-indigo-100 shadow-sm" data-id="element-225">
                <p className="text-lg text-slate-700 font-medium italic" data-id="element-226">
                  "Actúa como contador público especializado en normativa
                  fiscal. Explica de forma clara y sencilla el impuesto al valor
                  agregado (IVA) para un cliente que no tiene conocimientos
                  contables. Incluye ejemplos simples y evita lenguaje técnico
                  complejo."
                </p>
              </div>
            </div>

            {/* Result Box */}
            <div className="p-8 bg-slate-900 text-white" data-id="element-227">
              <div className="flex items-center gap-3 mb-4" data-id="element-228">
                <div className="bg-amber-500/20 p-2 rounded-lg" data-id="element-229">
                  <Bot className="w-6 h-6 text-amber-400" data-id="element-230" />
                </div>
                <h3 className="text-xl font-bold text-amber-400" data-id="element-231">Resultado:</h3>
              </div>
              <div className="bg-slate-800 p-6 rounded-xl border border-slate-700 shadow-inner" data-id="element-232">
                <p className="text-lg text-slate-300 font-medium" data-id="element-233">
                  ChatGPT genera una explicación profesional que puedes enviar
                  directamente al cliente en segundos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION - TESTIMONIOS */}
      <section className="py-16 px-4 bg-slate-50 border-y border-slate-200" data-id="element-234">
        <div className="max-w-5xl mx-auto" data-id="element-235">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-slate-900" data-id="element-236">
            Lo que dicen los contadores que ya lo usan
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-237">
            {/* Testimonio 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100" data-id="element-238">
              <div className="flex items-center gap-4 mb-5" data-id="element-239">
                <img src="https://i.pravatar.cc/80?img=47" alt="María González" className="w-14 h-14 rounded-full object-cover border-2 border-indigo-200" data-id="element-240" />
                <div data-id="element-241">
                  <p className="font-bold text-slate-900 text-lg" data-id="element-242">
                    María González
                  </p>
                  <p className="text-slate-500 text-sm font-medium" data-id="element-243">
                    Contadora - Buenos Aires
                  </p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-4" data-id="element-244">
                {[...Array(5)].map((_, i) => <span key={i} className="text-amber-400 text-xl" data-id="element-245">
                    ★
                  </span>)}
              </div>
              <p className="text-slate-600 font-medium leading-relaxed italic" data-id="element-246">
                "Los prompts me ahorraron horas de trabajo. Antes tardaba 30
                minutos redactando un correo para explicar impuestos a un
                cliente. Ahora lo hago en 2 minutos con resultados mucho más
                profesionales."
              </p>
            </div>

            {/* Testimonio 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100" data-id="element-247">
              <div className="flex items-center gap-4 mb-5" data-id="element-248">
                <img src="https://i.pravatar.cc/80?img=12" alt="Carlos Fernández" className="w-14 h-14 rounded-full object-cover border-2 border-indigo-200" data-id="element-249" />
                <div data-id="element-250">
                  <p className="font-bold text-slate-900 text-lg" data-id="element-251">
                    Carlos Fernández
                  </p>
                  <p className="text-slate-500 text-sm font-medium" data-id="element-252">
                    Contador Público - Córdoba
                  </p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-4" data-id="element-253">
                {[...Array(5)].map((_, i) => <span key={i} className="text-amber-400 text-xl" data-id="element-254">
                    ★
                  </span>)}
              </div>
              <p className="text-slate-600 font-medium leading-relaxed italic" data-id="element-255">
                "Implementar estos prompts en mi estudio fue un antes y un
                después. Automaticé las respuestas a consultas frecuentes y
                ahora puedo dedicar más tiempo a tareas estratégicas. Totalmente
                recomendado."
              </p>
            </div>

            {/* Testimonio 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100" data-id="element-256">
              <div className="flex items-center gap-4 mb-5" data-id="element-257">
                <img src="https://i.pravatar.cc/80?img=45" alt="Laura Martínez" className="w-14 h-14 rounded-full object-cover border-2 border-indigo-200" data-id="element-258" />
                <div data-id="element-259">
                  <p className="font-bold text-slate-900 text-lg" data-id="element-260">
                    Laura Martínez
                  </p>
                  <p className="text-slate-500 text-sm font-medium" data-id="element-261">
                    Estudio Contable - Rosario
                  </p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-4" data-id="element-262">
                {[...Array(5)].map((_, i) => <span key={i} className="text-amber-400 text-xl" data-id="element-263">
                    ★
                  </span>)}
              </div>
              <p className="text-slate-600 font-medium leading-relaxed italic" data-id="element-264">
                "Los prompts de comunicación con clientes me salvaron. Las
                respuestas estructuradas elevaron mi autoridad profesional. Ya
                no me preguntan lo mismo mil veces porque las explicaciones
                quedan claras desde el primer mensaje."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 - OFFER & PRICE */}
      <section id="compra" className="py-20 px-4 bg-white border-t border-slate-200" data-id="element-265">
        <div className="max-w-4xl mx-auto bg-slate-50 rounded-3xl p-8 md:p-12 border-4 border-indigo-500 shadow-2xl relative" data-id="element-266">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-2 rounded-full font-black text-lg md:text-xl shadow-lg whitespace-nowrap" data-id="element-267">
            ⏰ Acceso por tiempo limitado
          </div>

          <div className="text-center mb-6 mt-6" data-id="element-268">
            <h3 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-269">
              Precio especial de lanzamiento
            </h3>

            <p className="text-2xl text-slate-500 font-bold mb-3 line-through decoration-red-500 decoration-4" data-id="element-270">
              Precio normal: $19.990
            </p>

            <p className="text-2xl font-bold text-slate-800 mb-4" data-id="element-271">
              Hoy puedes acceder al ebook por solo:
            </p>

            <div className="mb-6" data-id="element-272">
              <p className="text-6xl md:text-7xl lg:text-8xl font-black text-green-600 mb-3" data-id="element-273">
                $9.990
              </p>
              <p className="text-xl font-bold text-slate-600 uppercase tracking-wide" data-id="element-274">
                Pago único. Acceso inmediato.
              </p>
            </div>

            <CTAButton text="👉 QUIERO LOS 100 PROMPTS PARA CONTADORES" href="https://fegion.shop/cart/46069738602635:1" isExternal={true} className="mb-6" data-id="element-275" />

            <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm max-w-2xl mx-auto text-left" data-id="element-276">
              <h4 className="text-xl font-bold text-slate-900 mb-4 text-center" data-id="element-277">
                Obtendrás:
              </h4>
              <ul className="space-y-3" data-id="element-278">
                <li className="flex items-center gap-3" data-id="element-279">
                  <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-280" />
                  <span className="text-lg font-medium text-slate-700" data-id="element-281">
                    Ebook digital con 100 prompts profesionales
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-282">
                  <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-283" />
                  <span className="text-lg font-medium text-slate-700" data-id="element-284">
                    Acceso inmediato después de la compra
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-285">
                  <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-286" />
                  <span className="text-lg font-medium text-slate-700" data-id="element-287">
                    Compatible con PC o celular
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-288">
            <div className="bg-white p-6 rounded-xl border border-slate-200 text-center shadow-sm" data-id="element-289">
              <ShieldCheck className="w-12 h-12 text-indigo-500 mx-auto mb-3" data-id="element-290" />
              <h4 className="font-bold text-slate-900 mb-2 text-lg" data-id="element-291">
                Garantía Segura
              </h4>
              <p className="text-sm text-slate-600" data-id="element-292">
                Si el contenido no cumple tus expectativas, puedes solicitar
                reembolso dentro del período establecido por la plataforma de
                pago. Tu compra es completamente segura.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200 text-center shadow-sm" data-id="element-293">
              <Zap className="w-12 h-12 text-amber-500 mx-auto mb-3" data-id="element-294" />
              <h4 className="font-bold text-slate-900 mb-2 text-lg" data-id="element-295">
                Acceso Inmediato
              </h4>
              <p className="text-sm text-slate-600" data-id="element-296">
                Después de realizar el pago recibirás acceso inmediato para
                descargar el ebook y empezar a usar los prompts hoy mismo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 - IMAGINE THIS */}
      <section className="py-20 px-4 bg-slate-900 text-white text-center" data-id="element-297">
        <div className="max-w-4xl mx-auto" data-id="element-298">
          <h2 className="text-4xl md:text-5xl font-black mb-12 text-amber-400" data-id="element-299">
            Imagina esto…
          </h2>

          <ul className="text-2xl md:text-3xl font-bold space-y-8 text-slate-200 mb-16" data-id="element-300">
            <li className="flex items-center justify-center gap-4" data-id="element-301">
              <CheckCircle2 className="text-green-400 w-8 h-8 flex-shrink-0" data-id="element-302" />{' '}
              Responder consultas de clientes en segundos.
            </li>
            <li className="flex items-center justify-center gap-4" data-id="element-303">
              <CheckCircle2 className="text-green-400 w-8 h-8 flex-shrink-0" data-id="element-304" />{' '}
              Generar informes profesionales más rápido.
            </li>
            <li className="flex items-center justify-center gap-4" data-id="element-305">
              <CheckCircle2 className="text-green-400 w-8 h-8 flex-shrink-0" data-id="element-306" />{' '}
              Analizar información financiera con ayuda de IA.
            </li>
            <li className="flex items-center justify-center gap-4 text-amber-400 text-3xl md:text-4xl font-black mt-12" data-id="element-307">
              <Zap className="w-10 h-10 flex-shrink-0" data-id="element-308" /> Y liberar horas de
              trabajo cada semana.
            </li>
          </ul>

          <p className="text-xl md:text-2xl text-slate-400 font-medium" data-id="element-309">
            Eso es exactamente lo que este ebook te permitirá hacer.
          </p>
        </div>
      </section>

      {/* NEW SECTION - IA ESTÁ CAMBIANDO */}
      <section className="py-20 px-4 bg-indigo-50 border-t border-indigo-100" data-id="element-310">
        <div className="max-w-4xl mx-auto text-center" data-id="element-311">
          <Bot className="w-16 h-16 text-indigo-600 mx-auto mb-8" data-id="element-312" />

          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-8 leading-tight" data-id="element-313">
            La inteligencia artificial está cambiando la forma en que trabajan
            los profesionales.
          </h2>

          <p className="text-xl md:text-2xl text-slate-700 font-medium mb-8 leading-relaxed" data-id="element-314">
            Los contadores que aprendan a usar herramientas como ChatGPT podrán
            trabajar más rápido, automatizar tareas repetitivas y dedicar más
            tiempo a lo que realmente importa.
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-indigo-200 inline-block" data-id="element-315">
            <p className="text-xl text-slate-500 font-bold mb-2" data-id="element-316">
              Mientras otros siguen trabajando manualmente…
            </p>
            <p className="text-2xl md:text-3xl font-black text-indigo-700" data-id="element-317">
              tú puedes empezar a usar inteligencia artificial en tu estudio
              contable desde hoy.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 9 - FINAL CTA */}
      <section className="py-24 px-4 bg-white text-center border-t border-slate-200" data-id="element-318">
        <div className="max-w-4xl mx-auto" data-id="element-319">
          <h2 className="text-4xl md:text-5xl font-black mb-8 text-slate-900" data-id="element-320">
            Última pregunta
          </h2>

          <div className="bg-indigo-50 p-8 md:p-10 rounded-2xl border border-indigo-100 mb-12" data-id="element-321">
            <p className="text-xl text-slate-600 mb-4 font-bold" data-id="element-322">
              La única pregunta es:
            </p>
            <p className="text-3xl md:text-4xl font-black text-indigo-700" data-id="element-323">
              ¿Vas a usarla a tu favor o vas a quedarte atrás?
            </p>
          </div>

          <p className="text-xl font-bold text-slate-800 mb-6" data-id="element-324">
            Haz clic en el botón de abajo y obtén acceso inmediato al ebook.
          </p>

          <CTAButton text="👉 ACCEDER AL EBOOK AHORA" href="https://fegion.shop/cart/46069738602635:1" isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-325" />

          <div className="text-center mt-6 text-sm text-slate-500 font-medium flex items-center justify-center gap-1" data-id="element-326">
            <Lock className="w-4 h-4" data-id="element-327" /> Pago 100% Seguro
          </div>
        </div>
      </section>
    </div>;
}